import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {ExactLogService} from '../../../Services/exact-log.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import * as moment from 'moment';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';


@Component({
  selector: 'app-exact-crm-updates-overview',
  templateUrl: './exact-retries-overview.component.html',
  styleUrls: ['./exact-retries-overview.component.scss']
})
export class ExactRetriesOverviewComponent implements OnInit {

  public grid: Grid;
  @ViewChild('modelTooltip', {static: true}) modelTooltip = null;

  constructor(
    private router: Router,
    public helper: Helper,
    private auth: AuthenticationService,
    private broadcastService: BroadcastService,
    private exactLogService: ExactLogService,
  ) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat();
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.exact_log.data_type',
          prop: 'dataType',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 200,
          valueFormatter: row => this.getDataType(row),
        },
        <TextColumn>{
          name: 'doctrine.exact_log.message',
          prop: 'message',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.modelTooltip,
        },
        <TextColumn>{
          name: 'doctrine.exact_log.date',
          prop: 'retryDate',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 250,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-check fa-lg',
              tooltip: 'global.retry',
              onclick: row => {
                this.exactLogService.acceptExactRetries(row.id).subscribe((resp) => {
                  this.broadcastService.broadcast('refreshGrid', 'getRetries');
                  this.exactLogService.getCrmUpdateNotificationsCount();
                });
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'feather icon-x fa-lg',
              tooltip: 'global.ignore',
              onclick: row => {
                this.exactLogService.rejectExactRetries(row.id).subscribe((resp) => {
                  this.broadcastService.broadcast('refreshGrid', 'getRetries');
                  this.exactLogService.getCrmUpdateNotificationsCount();
                });
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.exactLogService,
      rememberURL: this.router.url,
      method: 'getRetries',
      defaultSort: 'createdAt',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: false,
      doseNotHaveSearch: true,
    };
  }

  private getDataType(type) {
    const allTypes = ['CRM', 'Product', 'Invoice', 'Order', 'Connection'];
    return allTypes[type];
  }
}
